// docs/116 CI8: what a hero reads in the armchair by the fire (a title over their head, a page now and then).
import { hashN } from '../layout';

export const BOOKS: readonly string[] = [
  'A Herbal of the Marches', 'The Wyvern Who Wanted Tea', 'Sixty Knots for Sailors', 'Old Brannock\'s Almanac',
  'On the Care of Copper Pans', 'The Ballad of Sir Grumbold', 'A Child\'s Book of Stars', 'Riddles of the Barrow Kings',
  'The Miller\'s Seventh Daughter', 'Moss: A Love Story', 'Recipes from a Long Winter', 'Goblins and How to Talk to Them',
  'The Lay of the Lantern Road', 'A Treatise on Pies', 'Letters from a Lighthouse', 'The Lost Hours of Abbot Wend',
  'Birds of the Hedgerow', 'Twelve Nights at the Drowsy Lantern', 'The Gentle Art of Doing Nothing', 'Maps of Places That Moved',
  'The Fox and the Ferryman', 'Songs to Sing to Bees', 'A Short History of Very Long Beards', 'The Owl Who Kept the Library',
  'Weather Lore for Shepherds', 'The Knight of the Small Hours', 'Cheeses of the Known World', 'Tales Told by the Fire',
];

/** The book `heroKey` picks up in this village (the same one each time they sit down there). */
export const bookFor = (seed: number, heroKey: string): string => BOOKS[Math.floor(hashN(seed, [...heroKey].reduce((s, c) => s + c.charCodeAt(0), 0), 77) * BOOKS.length)]!;
